import { Leaf, Instagram } from "lucide-react";
import { TEAM_MEMBERS } from "./constants";

export default function TeamSection() {
  return (
    <section data-testid="team-section" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-forest-500 font-medium tracking-wider uppercase text-sm">Working People</span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-forest-700 font-bold mt-3 mb-4">
            Our Awesome Creative Best
            <span className="block">Team Members</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 max-w-7xl mx-auto">
          {TEAM_MEMBERS.map((member) => (
            <div
              key={member.id}
              data-testid={`team-card-${member.id}`}
              className="team-card group relative bg-sand-100 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500"
            >
              <div className="aspect-[3/4] overflow-hidden">
                {member.image ? (
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-forest-100 to-forest-200 flex items-center justify-center">
                    <div className="text-center">
                      <div className="w-24 h-24 bg-forest-300/50 rounded-full flex items-center justify-center mx-auto mb-4">
                        <Leaf className="w-12 h-12 text-forest-500" />
                      </div>
                      <p className="text-forest-600 text-sm font-medium">Photo Coming Soon</p>
                    </div>
                  </div>
                )}
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-forest-700/90 via-forest-700/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="absolute bottom-24 left-0 right-0 flex justify-center gap-3">
                  <a
                    href={member.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-forest-600 hover:bg-forest-500 hover:text-white transition-all duration-300 transform translate-y-4 group-hover:translate-y-0"
                  >
                    <Instagram className="w-5 h-5" />
                  </a>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-white p-6 text-center transform translate-y-0 group-hover:translate-y-0 transition-transform duration-500">
                <h3 className="font-serif text-xl text-forest-700 font-bold mb-1">{member.name}</h3>
                <p className="text-stone-500 text-sm">{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
